/* eslint-disable quotes */
export const actionTypes = {
  toggleDmDrawer: 'TOGGLE-DM-DRAWER',
  getUsersForDms: 'GET-USERS-FOR-DMS',
  selectDmUser: 'SELECT-DM-USER',
  sendDm: 'SEND-DM',
  postMessageToDM: 'POST-MESSAGE-TO-DM',
  updateChat: 'UPDATE-CHAT',
  toggleUserSigninDialog: "TOGGLE-USER-SIGNIN-DIALOG",
  toggle2FaVerificationDialog: "TOGGLE-2FA-VERIFY-DIALOG",
  initiateSignin: "INITIATE-SIGNIN",
  finalizeSignIn: "FINALIZE-SIGNIN",
  signinFailed: "SIGNIN-FAILED",
  hideLoginErrorMsg: "HIDE-LOGIN-ERROR-MSG",
  resend2Fa: "RESEND-2FA",
  hide2FaErrorMsg: "HIDE-2FA-ERROR-MSG",
  _2faVerificationFailed: "2FA-VERIFICATION-FAILED",
  isSignedIn: "IS-SIGNED-IN",
  logout: "LOGOUT",
  updateBanner: "UPDATE-BANNER",
  updateAvatar: "UPDATE-AVATAR",
  updateProfile: "UPDATE-PROFILE",

  /* ************************************************************************ */
  /* SHARED SECTIONS (Related to searching providers, practices etc.)         */
  /* ************************************************************************ */
  initiateFacilitySearch: "INITIATE_FACILITY_SEARCH",
  searchFacilities: "SEARCH_FACILITIES",
  resetFacilitySearch: "RESET_FACILITY_SEARCH",
  initiateSurgeonSearch: "INITIATE_SURGEON_SEARCH",
  searchSurgeons: "SEARCH_SURGEONS",
  resetSurgeonSearch: "RESET_SURGEON_SEARCH",
  initiateAnesthesiologistSearch: "INITIATE_ANESTHESIOLOGIST_SEARCH",
  searchAnesthesiologists: "SEARCH_ANESTHESIOLOGISTS",
  resetAnesthesiologistSearch: "RESET_ANESTHESIOLOGIST_SEARCH",
  initiateCrnaSearch: "INITIATE_CRNA_SEARCH",
  searchCrnas: "SEARCH_CRNAS",
  resetCrnaSearch: "RESET_CRNA_SEARCH",
  initiateCptSearch: "INITIATE_CPT_SEARCH",
  searchCpt: "SEARCH_CPT",
  resetCptSearch: "RESET_CPT_SEARCH",
  initiateAnesthesiaProcedureSearch: "INITIATE_ANESTHESIA_PROCEDURE_SEARCH",
  searchAnesthesiaProcedures: "SEARCH_ANESTHESIA_PROCEDURES",
  resetAnesthesiaProcedureSearch: "RESET_ANESTHESIA_PROCEDURE_SEARCH",
  initiateIcd10Search: "INITIATE_ICD10_SEARCH",
  searchIcd10: "SEARCH_ICD_10",
  resetIcd10Search: "RESET_ICD10_SEARCH",
  // Providers related actions
  addProvider: "ADD-PROVIDER",
  getProviders: "GET-PROVIDERS",
  addFacility: "ADD-FACILITY",
  addPractice: "ADD-PRACTICE",
  toggleResetPasswordDialog: "TOGGLE-RESET-PASSWORD-DIALOG",
  sendTempPassword: "SEND-TEMP-PASSWORD",
  resetPassword: "RESET-PASSWORD",
  resendTempPassword: "RESEND-TEMP-PASSWORD",
  initiateResendTempPasswordEmail: 'INITIATE-RESEND-TEMP-PASSWORD-EMAIL',
  // TODO: Delete initiateProviderSignIn action-type
  initiateProviderSignIn: "INITIATE-PROVIDER-SIGNIN",
  finalizeProviderSignIn: "FINALIZE-PROVIDER-SIGNIN",
  providerSigninFailed: "PROVIDER-SIGNIN-FAILED",
  updateProviderProfile: "UPDATE-PROVIDER-PROFILE",
  // Not used so far ...
  signinSuccessful: "SIGNIN-SUCCESSFULL",
  updateProviderBanner: "UPDATE-PROVIDER-BANNER",
  updateProviderAvatar: "UPDATE-PROVIDER-AVATAR",
  setActiveRecord: "SET-ACTIVE-RECORD",
  // Practice dashboard actions
  updatePracticeBanner: "UPDATE-PRACTICE-BANNER",
  updatePracticeAvatar: "UPDATE-PRACTICE-AVATAR",
  updatePracticeProfile: "UPDATE-PRACTICE-PROFILE",
  // User dashboard actions
  updateUserBanner: "UPDATE-USER-BANNER",
  updateUserAvatar: "UPDATE-USER-AVATAR",
  updateUserProfile: "UPDATE-USER-PROFILE",
  // -- Data reload switch ----------------------------------------------------
  togglePracticeDataReloadFlag: "TOGGLE-PRACTICE-DATA-RELOAD-FLAG",
  reloadData: "RELOAD-DATA",
  // -- App Alerts ------------------------------------------------------------
  addAppAlert: "ADD-APP-ALERT",
  addAppAlertWithStateReset: 'ADD-APP-ALERT-WITH-STATE-RESET',
  hideAppAlert: "HIDE-APP-ALERT",
  deleteAppAlert: "DELETE-APP-ALERT",
  getNotifications: "GET-NOTIFICATIONS",
  setNotificationsCount: "SET-NOTIFICATIONS-COUNT",
  clearChatBadge: "CLEAR-CHAT-BADGE",
  // -- Create & Search Patient -----------------------------------------------
  searchPatients: "SEARCH-PATIENTS",
  createPatient: "CREATE-PATIENT",

  /* ************************************************************************ */
  /* Case Schedules Section                                                   */
  /* ************************************************************************ */

  // -- SCHEDULE PAGE ---------------------------------------------------------
  setSelectedPractice: "SET_SELECTED_PRACTICE",
  setSelectedCaseBlockDate: 'SET-SELECTED-CASE-BLOCK-DATE',
  openCaseSchedule: "OPEN-CASE-SCHEDULE",
  deleteCaseSchedule: "DELETE-CASE-SCHEDULE",
  submitCaseSchedule: "SUBMIT-CASE-SCHEDULE",
  cancelCaseSchedule: "CANCEL-CASE-SCHEDULE",
  collapseReload: 'COLLAPSE-RELOAD',

  // -- Case Schedule ---------------------------------------------------------
  setCaseTabFlag: "SET_CASE_TAB_FLAG",
  setOpMode: "SET_OP_MODE",
  setLoadingCaseData: "SET-LOADING-CASE-DATA",
  shouldResyncCaseData: "SHOULD_RESYNC_CASE_DATA",
  resetCaseBlockLinkTimeFlag: 'RESET-CASE-BLOCK-LINK-TIME-FLAG',

  // -- New Case --------------------------------------------------------------
  initiateNewCaseSchedule: "INITIATE_NEW_CASE_SCHEDULE",                        // Reset newCaseSchedule data and prepare for creating a new case schedule
  toggleNewCaseScheduleWarningDialog1: "TOGGLE_NCS_WARNING_DILOG_1",
  toggleNewCaseScheduleWarningDialog2: "TOGGLE_NCS_WARNING_DILOG_2",
  updateNewCaseScheduleData: "UPDATE_NEW_CASE_SCHEDULE_DATA",
  createNewCaseSchedule: "CREATE_NEW_CASE_SCHEDULE",                            // Send request to server to create new case schedule

  // -- New Case Schedule Patient ---------------------------------------------
  addPatientToNewCaseSchedule: "ADD_PATIENT_TO_NEW_CASE_SCHEDULE",
  updatePatientToNewCaseSchedule: "UPDATE_PATIENT_TO_NEW_CASE_SCHEDULE",
  deletePatientFromNewCaseSchedule: "DELETE_PATIENT_FROM_NEW_CASE_SCHEDULE",
  reloadCaseSchedulePatientData: "RELOAD_CASE_SCHEDULE_PATIENT_DATA",

  // -- Existing Case Schedules -----------------------------------------------
  clearCaseSchedulesData: 'CLEAR-CASE-SCHEDULES-DATA',
  getCaseSchedulesData: "GET-CASE-SCHEDULES-DATA",                              // All case schedules
  loadCaseSchedule: "LOAD-CASE-SCHEDULE",
  updateCaseSchedule: "UPDATE-CASE-SCHEDULE",
  getCaseSchedulePatientData: "GET_CASE_SCHEDULE_PATIENT_DATA",
  saveCaseSchedule: "SAVE_CASE_SCHEDULE",
  toggleCaseLoader: 'TOOGLE_CASE_LOADER',

  // -- Existing Case Schedule Patient ----------------------------------------
  addPatientToExistingCaseSchedule: "ADD_PATIENT_TO_EXISTING_CASE_SCHEDULE",
  updatePatientToExistingCaseSchedule: "UPDATE_PATIENT_TO_NEW_CASE_SCHEDULE",
  deletePatientFromCaseSchedule: "DELETE_PATIENT_FROM_CASE_SCHEDULE",
  reloadExistingCaseSchedulePatientData: "RELOAD_ECS_PATIENT_DATA",

  /* ************************************************************************ */
  /* Case Blocks Section                                                      */
  /* ************************************************************************ */
  // -- Case Blocks  (Gantt Grid)
  // TODO: Either delete this action or the resetCaseBlockState action.
  toggleCbLoader: 'TOGGLE-CB-LOADER',                                           // Toggle case block loader
  toggleScheduleCaseDrawer: 'TOGGLE-SCHEDULE-CASE-DRAWER',
  toggleCaseBlockDrawer: 'TOGGLE-CASE-BLOCK-DRAWER',
  initiateNewCaseBlock: 'INITIATE-NEW-CASE-BLOCK',                              // Initialize new case block
  loadCaseBlocksData: 'LOAD-CASE-BLOCK-DATA',                                   // Load case blocks data for Gantt Grid
  createNewCaseBlock: 'CREATE-NEW-CASE-BLOCK',                                  //
  editCaseBlock: 'EDIT-CASE-BLOCK',                                             // Edit existing case block
  updateCaseBlockData: 'UPDATE-CASE-BLOCK-DATA',
  saveCaseBlock: 'SAVE-CASE-BLOCK',
  setEditCaseBlockCases: 'SET-EDIT-CASE-BLOCK-CASES',                           //
  addPatientToCaseBlock: 'ADD-PATIENT-TO-CASE-BLOCK',
  deletePatientFromCaseBlock: 'DELETE-PATIENT-FROM-CASE-BLOCK',
  reloadCaseBlockCasePatientData: 'RELOAD-CASE-BLOCK-CASE-PATIENT-DATA',
  updateCaseBlockFilterDate: 'UPDATE-CASE-BLOCK-FILTER-DATE',                   //
  resetCaseBlocksState: 'RESET_CASE_BLOCKS_STATE',                              // Reset case block state
  updateCaseBlockAnesthesiologist: 'UPDATE-CASE-BLOCK-ANESTHESIOLOGIST',        // Update case block Anesthesiologist
  updateCaseBlockCrna: 'UPDATE-CASE-BLOCK-CRNA',                                // Update case block Crna
  getProvidersSchedule: 'GET-PROVIDERS-SCHEDULE',                               // Provider case times
  addDirectorBlock: 'ADD-DIRECTOR-BLOCKS',                                      // Create new director block
  updateDirectorBlock: 'UPDATE-DIRECTOR-BLOCK',                                 // Update director block
  addShiftBlock: 'ADD-SHIFT-BLOCK',                                             // Create new shift block
  updateShiftBlock: 'UPDATE-SHIFT-BLOCK',                                       // Update shift block
  addCallBlock: 'ADD-CALL-BLOCK',                                               // Create new call block
  updateCallBlock: 'UPDATE-CALL-BLOCK',                                         // Update call block
  saveFacilityColors: 'SAVE-FACILITY-COLORS',                                   // Save Gant grid left pinned facility background and text color

  // -- New Caseblock Case ----------------------------------------------------
  initiateNewCaseBlockCase: "INITIATE-NEW-CASE-BLOCK-CASE",
  setCaseBlockCaseInitialData: "SET-CASE-BLOCK-CASE-INITIAL-DATA",
  setCaseBlockActiveCaseSchedule: 'SET-CASE-BLOCK-ACTIVE-CASE-SCHEDULE',
  toggleCbCaseScheduleDashboard: 'TOGGLE-CB-CASE-SCHEDULE-DASHBOARD',
  updateCaseBlockActiveCaseSchedule: 'UPDATE-CASE-BLOCK-ACTIVE-CASE-SCHEDULE',
  setActiveCaseBlockCase: "SET-ACTIVE-CASE-BLOCK-CASE",
  markCaseBlockCaseForCreation: "MARK-CASE-BLOCK-CASE-FOR-CREATION",
  editCaseBlockCaseMarkedForCreation: "EDIT-CASE-BLOCK-CASE-MARKED-FOR-CREATION",
  updateCaseBlockCaseMarkedForCreation: "UPDATE-CASE-BLOCK-CASE-MARKED-FOR-CREATION",
  unMarkCaseBlockCaseForCreation: "UNMARK-CASE-BLOCK-CASE-FOR-CREATION",
  markCaseForUpdate: 'MARK-CASE-FOR-UPDATE',
  markCaseBlockCaseForDeletion: "MARK-CASE-BLOCK-CASE-FOR-DELETION",
  unMarkCaseBlockCaseForDeletion: "UNMARK-CASE-BLOCK-CASE-FOR-DELETION",

  // -- Existing Caseblock Case(s) --------------------------------------------
  setExistingCaseBlockCases: "SET-EXISTING-CASE-BLOCK-CASES",
  // -- Case Schedule Date Range Filter
  setCaseScheduleDateRangeFilterStartDate: 'SET-CASE-SCHEDULE-DATE-RANGE-FITLER-START-DATE',
  setCaseScheduleDateRangeFilterEndDate: 'SET-CASE-SCHEDULE-DATE-RANGE-FITLER-END-DATE',
  // ---
  setShouldSaveCaseData: 'SET-SHOULD-SAVE-CASE-DATA'
};
